import React from 'react';
import useLikesMergeObserver, { ObserverParams } from '../../effects/useLikesMergeObserver';

// обертка над хуком для классовых компонентов
// позже можно будет удалить
const LikesMergeObserver = (props: ObserverParams) => {
  useLikesMergeObserver(props);

  return null;
};

export default LikesMergeObserver;
